// client/src/utils/defaultTournamentData.js
import { nanoid } from 'nanoid';
import { REQUIRED_LEVEL_KEY, REQUIRED_TIME_KEY } from '../constants/tournament';
import { parseTime } from './viewHelpers';



export function getDefaultTournamentData() {
  const defaultColumns = [
    { id: `col-${REQUIRED_LEVEL_KEY}`, label: REQUIRED_LEVEL_KEY },
    { id: "col-SB",    label: "SB"    },
    { id: "col-BB",    label: "BB"    },
    { id: "col-Ante",  label: "Ante"  },
    { id: `col-${REQUIRED_TIME_KEY}`,  label: REQUIRED_TIME_KEY  },
  ];

  const defaultLevels = [
    { id: `row-def-1-${nanoid(5)}`, type: "level", level: 1, SB: 200, BB: 400, Ante: 100, time: "20:00" },
    { id: `row-def-2-${nanoid(5)}`, type: "level", level: 2, SB: 400, BB: 800, Ante: 200, time: "20:00" },
    { id: `row-def-3-${nanoid(5)}`, type: "level", level: 3, SB: 600, BB: 1200, Ante: 300, time: "20:00" }
  ].map(row => {
    const newRow = { ...row };
    if (!newRow.hasOwnProperty(REQUIRED_LEVEL_KEY)) newRow[REQUIRED_LEVEL_KEY] = newRow.level;
    if (REQUIRED_LEVEL_KEY !== 'level' && newRow.hasOwnProperty('level')) delete newRow.level;

    if (!newRow.hasOwnProperty(REQUIRED_TIME_KEY)) newRow[REQUIRED_TIME_KEY] = newRow.time;
    if (REQUIRED_TIME_KEY !== 'time' && newRow.hasOwnProperty('time')) delete newRow.time;
    return newRow;
  });

  const initialStructure = {
    tournamentName: "",
    columns: defaultColumns,
    levels: defaultLevels,
    events: []
  };

  const initialDetails = {
    initialStack: 20000,
    rebuyStack: 0,
    addonStack: 0,
    initialEntries: 0,
    knockouts: 0,
    totalRebuys: 0,
    totalAddons: 0,
    showPlayerStats: false,
    isPaid: false,
    customInfoText: "", // customInfoTextを追加
    forfeitedChips: 0,
  };
  
  const initialTimerState = {
    rowIndex: 0,
    value: parseTime(initialStructure.levels[0]?.[REQUIRED_TIME_KEY] || "0:00"),
    remaining: parseTime(initialStructure.levels[0]?.[REQUIRED_TIME_KEY] || "0:00"), // remainingを追加
    intervalId: null, // クライアント側では使用しない
    state: 'ready',
    hasTournamentStarted: false,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  };

  return {
    name: initialStructure.tournamentName,
    structure: initialStructure,
    timer_state: initialTimerState,
    details: initialDetails,
  };
}
